import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Pagination } from "react-bootstrap";

const jwt = require("jsonwebtoken");
import { API_END_POINT } from "../config";
import { JWT_SECRET_TOKEN } from "../config";
import Cookie from "js-cookie";
const token = Cookie.get("waffle_world_access_token");

export default class Users extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      activePage: 1,
      pages: 1,
      q: "",
      loading: false,
      responseMessage: "Loading Users...",
      status: "accepted",
      acceptedUsers: [],
      unAcceptedUsers: [],
    };
  }
  componentWillMount() {
    this.fetchUsers(this.state.status);
  }

  fetchUsers = (value) => {
    this.setState({
      status: value,
      acceptedUsers: [],
      unAcceptedUsers: [],
      loading: true,
      responseMessage: "Loading Users...",
    });
    const tokenx = jwt.sign({ payload: value }, JWT_SECRET_TOKEN, {
      expiresIn: "1h",
    });
    axios
      .get(`${API_END_POINT}/api/users`, {
        headers: { "auth-token": tokenx, "x-api-key": JWT_SECRET_TOKEN },
      })
      .then((response) => {
        let SortedArray = response.data.objects;
        SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
        this.setState({
          users: SortedArray,
          pages: Math.ceil(response.data.length / 10),
          loading: false,
          responseMessage: "No Users Found",
        });
      });
  };

  deleteUser(userId, index) {
    const requestParams = {
      userId: userId,
    };
    if (confirm("Are you sure you want to delete this user?")) {
      console.log(JWT_SECRET_TOKEN);

      axios
        .delete(`${API_END_POINT}/api/users/deleteasadmin`, {
          data: requestParams,
          headers: { "auth-token": JWT_SECRET_TOKEN },
        })
        .then((response) => {
          const users = this.state.users.slice();
          users.splice(index, 1);
          this.setState({ users });
          window.alert(response.data.message);
        });
    }
  }

  handleSelect(page) {
    axios.get(`/api/area?offset=${(page - 1) * 10}`).then((response) => {
      this.setState({
        areas: response.data.items,
        activePage: page,
      });
    });
  }

  handleSearch() {
    axios.get(`/api/area?q=${this.state.q}`).then((response) => {
      this.setState({
        areas: response.data.items,
        activePage: 1,
        pages: Math.ceil(response.data.total / 10),
      });
    });
  }

  handleSearch() {
    const { q } = this.state;
    if (q.length) {
      this.setState({
        loading: true,
        users: [],
        responseMessage: "Loading Users...",
      });
      const tokenx = jwt.sign({ payload: q }, JWT_SECRET_TOKEN, {
        expiresIn: "1h",
      });
      axios
        .get(`${API_END_POINT}/api/users/search`, {
          params: { searchWord: this.state.q },
          headers: { "auth-token": tokenx },
        })
        .then((response) => {
          let SortedArray = response.data.searchedItems;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            users: SortedArray,
            loading: false,
            responseMessage: "No Users Found...",
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            responseMessage: "No Users Found...",
          });
        });
    }
  }

  acceptUser = (userId, index) => {
    axios
      .post(`${API_END_POINT}/api/admins/userstatus`, {
        userId: userId,
        status: true,
      })
      .then((response) => {
        console.log("response....", response);
        const acceptedUsers = this.state.acceptedUsers.slice();
        users.splice(index, 1);
        this.setState({ acceptedUsers });
        window.alert(response.data.message);
      })
      .catch((err) => {
        window.alert("ERROR ACCEPTING USER!");
      });
  };

  rejectUser = (userId, index) => {
    axios
      .post(`${API_END_POINT}/api/admins/userstatus`, {
        userId: userId,
        status: false,
      })
      .then((response) => {
        const unAcceptedUsers = this.state.unAcceptedUsers.slice();
        users.splice(index, 1);
        this.setState({ unAcceptedUsers });
        window.alert(response.data.message);
      })
      .catch((err) => {
        window.alert("ERROR REJECTING USER!");
      });
  };

  render() {
    console.log(this.state);
    const { loading, users, responseMessage, status } = this.state;
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row space-1">
            <div className="col-sm-4">
              <h3>Liste der Benutzer</h3>
            </div>
            <div className="col-sm-4">
              <div className="input-group">
                <input
                  onChange={(event) =>
                    this.setState({ q: event.target.value }, () => {
                      if (this.state.q === "") {
                        this.fetchUsers();
                      }
                    })
                  }
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      this.handleSearch();
                    }
                  }}
                  className="form-control"
                  type="text"
                  name="search"
                  placeholder="Enter search keyword"
                  value={this.state.q}
                  // onChange={(event) => this.setState({ q: event.target.value })}
                />
                <span className="input-group-btn">
                  <button
                    type="button"
                    onClick={() => this.handleSearch()}
                    className="btn btn-info search-btn"
                  >
                    Suche
                  </button>
                </span>
              </div>
            </div>
            <div className="col-sm-4 pull-right mobile-space">
              <Link to="/users/user_form">
                <button type="button" className="btn btn-success">
                  Neuen Benutzer hinzufügen
                </button>
              </Link>
            </div>
          </div>

          {/* <div className="row justify-content-between">
            <div className="float-left col-sm-6 space-1">
              <button
                type="button"
                style={{
                  marginRight: 5,
                  borderRadius: 0,
                }}
                className={`${
                  status === "accepted" ? "btn-primary" : ""
                } btn btn-default`}
                onClick={() => this.fetchUsers("accepted")}
              >
                Accepted Users
              </button>

              <button
                type="button"
                style={{
                  marginLeft: 5,
                  marginRight: 5,
                  borderRadius: 0,
                }}
                className={`${
                  status === "un-accepted" ? "btn-primary" : ""
                } btn btn-default`}
                onClick={() => this.fetchUsers("un-accepted")}
              >
                Un-Accepted Users
              </button>
            </div>
          </div> */}

          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Kundennummer</th>
                  <th>Name</th>
                  <th>E-Mail</th>
                  <th>Telefon Nummer</th>
                </tr>
              </thead>
              <tbody>
                {users && users.length >= 1 ? (
                  users.map((user, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {/* <td>{<img style={{height: '50px', width: '50px'}} src={user.profile_picture && user.profile_picture.url} />}</td> */}
                      <td>
                        {user.firstname} {user.lastname}
                      </td>
                      <td>{user.email}</td>
                      <td>{user.phoneNumber || "N/A"}</td>
                      <td>
                        <span
                          className="fa fa-trash"
                          style={{ cursor: "pointer" }}
                          aria-hidden="true"
                          onClick={() => this.deleteUser(user._id, index)}
                        ></span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      {responseMessage}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="text-center">
            <Pagination prev next items={this.state.pages} activePage={this.state.activePage} onSelect={this.handleSelect.bind(this)}> </Pagination>
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Users.jsx